/**
 * Manual Search Compare mode.
 * Saved diamonds confirmed available are shown in the existing Search grid.
 * compare=1 is only a results-source flag. It does not create a second store.
 */
(function (window, document) {
  "use strict";

  if (window.DiamondSearchCompare && window.DiamondSearchCompare.COMPARE_PARAM === "compare") {
    return;
  }

  var COMPARE_PARAM = "compare";
  var active = false;

  function bridge() {
    return window.DiamondSearchCompareBridge || null;
  }

  function pageUrl() {
    return new URL(window.location.href);
  }

  function hasCompare() {
    try {
      return pageUrl().searchParams.get(COMPARE_PARAM) === "1";
    } catch (err) {
      return false;
    }
  }

  function writeUrl(url, replace) {
    var next = url.pathname + url.search + url.hash;
    if (replace) history.replaceState(history.state, "", next);
    else history.pushState(history.state, "", next);
  }

  function urlWithCompare(on) {
    var url = pageUrl();
    if (on) url.searchParams.set(COMPARE_PARAM, "1");
    else url.searchParams.delete(COMPARE_PARAM);
    return url;
  }

  function layout() {
    return document.getElementById("diamondSearchLayout");
  }

  function grid() {
    return document.getElementById("diamondGrid");
  }

  var inventoryCount = null;

  function formatNumber(value) {
    var n = Number(value);
    if (!isFinite(n)) return "";
    try {
      return n.toLocaleString("en-US");
    } catch (err) {
      return String(n);
    }
  }

  function noteInventory() {
    if (active) return;
    var fromApi = null;
    if (typeof window.getResultCount === "function") {
      try {
        var raw = window.getResultCount();
        if (raw != null && isFinite(Number(raw))) fromApi = Number(raw);
      } catch (err) {
        fromApi = null;
      }
    }
    if (fromApi != null) {
      inventoryCount = fromApi;
      return;
    }
    var el = document.querySelector("[data-results-count]");
    if (!el || el.hidden) return;
    var digits = String(el.textContent || "").replace(/,/g, "").trim();
    if (!/^\d+$/.test(digits)) return;
    inventoryCount = Number(digits);
  }

  function availableCount() {
    var api = bridge();
    if (!api || typeof api.availableCount !== "function") return 0;
    var n = Number(api.availableCount());
    return isFinite(n) ? n : 0;
  }

  function bindExit(button) {
    if (!button || button.getAttribute("data-compare-exit-bound") === "true") return;
    button.setAttribute("data-compare-exit-bound", "true");
    button.addEventListener("click", function (event) {
      if (event && event.preventDefault) event.preventDefault();
      exitToSearch(false);
    });
  }

  function setPressed(button, on) {
    if (!button) return;
    if (button.classList && typeof button.classList.toggle === "function") {
      button.classList.toggle("is-active", on === true);
    }
    var cls = String(button.className || "");
    var has = (" " + cls + " ").indexOf(" is-active ") !== -1;
    if (on && !has) button.className = (cls + " is-active").trim();
    if (!on && has) button.className = cls.replace(/\bis-active\b/g, "").replace(/\s+/g, " ").trim();
    if (typeof button.setAttribute === "function") {
      button.setAttribute("aria-pressed", on ? "true" : "false");
    }
  }

  function ensureSwitcher() {
    var host = document.querySelector(".diamond-search__controls-left");
    if (!host) return null;
    var sw = host.querySelector(".diamond-search-compare-switch");
    if (sw) return sw;
    sw = document.createElement("div");
    sw.className = "diamond-search-compare-switch";
    sw.setAttribute("role", "group");
    sw.setAttribute("aria-label", "Diamond results");
    sw.innerHTML =
      '<button type="button" class="diamond-search-compare-switch__btn is-active" data-compare-all></button>' +
      '<button type="button" class="diamond-search-compare-switch__btn" data-compare-switch hidden></button>';
    if (host.firstChild) host.insertBefore(sw, host.firstChild);
    else if (host.appendChild) host.appendChild(sw);
    var all = sw.querySelector("[data-compare-all]");
    var cmp = sw.querySelector("[data-compare-switch]");
    if (all) {
      all.addEventListener("click", function (event) {
        if (event && event.preventDefault) event.preventDefault();
        if (active) exitToSearch(false);
      });
    }
    if (cmp) {
      cmp.addEventListener("click", function (event) {
        if (event && event.preventDefault) event.preventDefault();
        enter();
      });
    }
    return sw;
  }

  function ensureFooter() {
    var el = grid();
    if (!el || !el.parentNode) return null;
    var parent = el.parentNode;
    var existing =
      typeof parent.querySelector === "function"
        ? parent.querySelector("[data-compare-return-end]")
        : null;
    if (existing) return existing;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "diamond-search-compare-end";
    btn.setAttribute("data-compare-return-end", "true");
    btn.hidden = true;
    btn.textContent = "\u2190 Return to all diamonds";
    bindExit(btn);
    if (el.nextSibling && typeof parent.insertBefore === "function") {
      parent.insertBefore(btn, el.nextSibling);
    } else if (typeof parent.appendChild === "function") {
      parent.appendChild(btn);
    } else if (typeof parent.insertBefore === "function") {
      parent.insertBefore(btn, null);
    }
    return btn;
  }

  function syncSwitcher() {
    noteInventory();
    var n = availableCount();
    var sw = ensureSwitcher();
    if (sw) {
      var all = sw.querySelector("[data-compare-all]");
      var cmp = sw.querySelector("[data-compare-switch]");
      if (all) {
        all.textContent =
          inventoryCount == null
            ? "All diamonds"
            : "All diamonds (" + formatNumber(inventoryCount) + ")";
        setPressed(all, !active);
      }
      if (cmp) {
        cmp.hidden = n < 1;
        cmp.textContent = "Compare (" + n + ")";
        setPressed(cmp, active && n >= 1);
        if (typeof cmp.setAttribute === "function") {
          if (n < 1) cmp.setAttribute("aria-hidden", "true");
          else cmp.removeAttribute("aria-hidden");
        }
      }
    }
    var end = ensureFooter();
    if (end) end.hidden = active !== true;
    var sort = document.querySelector(".diamond-search__sort");
    var sortSelect = sort && typeof sort.querySelector === "function" ? sort.querySelector("select") : null;
    if (sort) {
      sort.removeAttribute("hidden");
      sort.removeAttribute("aria-hidden");
    }
    if (sortSelect) {
      sortSelect.disabled = active === true;
      if (active) sortSelect.setAttribute("aria-disabled", "true");
      else sortSelect.removeAttribute("aria-disabled");
    }
    var button = document.getElementById("diamondSearchCompare");
    if (button) {
      var on = active === true && n >= 1;
      if (on) {
        button.hidden = false;
        if (typeof button.removeAttribute === "function") button.removeAttribute("aria-hidden");
      }
      if (button.classList) {
        if (on) button.classList.add("is-compare-active");
        else button.classList.remove("is-compare-active");
      }
    }
    syncBackControl();
  }

  function syncBackControl() {
    var slot = document.querySelector(".diamond-search__count");
    if (!slot || typeof slot.appendChild !== "function") return null;
    var back = typeof slot.querySelector === "function" ? slot.querySelector("[data-compare-back]") : null;
    if (!back) {
      back = document.createElement("button");
      back.type = "button";
      back.className = "diamond-search-compare-back";
      back.setAttribute("data-compare-back", "true");
      back.hidden = true;
      bindExit(back);
      slot.appendChild(back);
    }
    if (!active) {
      back.hidden = true;
      return back;
    }
    back.hidden = false;
    if (typeof back.querySelector === "function" && back.querySelector("[data-compare-back-full]")) {
      return back;
    }
    var full = document.createElement("span");
    full.className = "diamond-search-compare-back__full";
    full.setAttribute("data-compare-back-full", "true");
    full.textContent = "\u2190 Back to All Diamonds";
    var narrow = document.createElement("span");
    narrow.className = "diamond-search-compare-back__short";
    narrow.setAttribute("data-compare-back-short", "true");
    narrow.textContent = "\u2190 All Diamonds";
    back.textContent = "";
    back.appendChild(full);
    back.appendChild(narrow);
    return back;
  }

  function setModeChrome(on) {
    var host = layout();
    if (host && host.classList) host.classList.toggle("is-compare-mode", on === true);
    syncSwitcher();
    var api = bridge();
    if (api && typeof api.refreshControl === "function") api.refreshControl();
    syncSwitcher();
  }

  function paintStatus(message) {
    var el = grid();
    if (!el) return;
    el.setAttribute("data-results-state", "loading");
    el.setAttribute("aria-busy", "true");
    el.innerHTML =
      '<div class="diamond-empty-state" role="status"><p class="diamond-empty-state__title">' +
      message +
      "</p></div>";
  }

  function paintCards(diamonds) {
    var el = grid();
    var api = bridge();
    if (!el || !api || typeof api.createCard !== "function") return;
    el.setAttribute("data-results-state", "results");
    el.setAttribute("aria-busy", "false");
    el.innerHTML = "";
    diamonds.forEach(function (diamond) {
      el.appendChild(api.createCard(diamond));
    });
  }

  function renderActive() {
    var api = bridge();
    if (!api || !active) return;
    var diamonds = api.listAvailableDiamonds ? api.listAvailableDiamonds() : [];
    var count = typeof api.availableCount === "function" ? api.availableCount() : diamonds.length;
    var pending = typeof api.isBatchPending === "function" && api.isBatchPending();
    var unknown = typeof api.unclassifiedCount === "function" ? api.unclassifiedCount() : 0;
    if (!diamonds.length && pending) {
      if (typeof api.setResultCountOverride === "function") api.setResultCountOverride(null);
      paintStatus("Loading saved diamonds\u2026");
      return;
    }
    if (!diamonds.length && !pending && unknown > 0) {
      exitToSearch(true);
      return;
    }
    if (!diamonds.length && !pending) {
      exitToSearch(true);
      return;
    }
    if (typeof api.setResultCountOverride === "function") api.setResultCountOverride(count);
    if (typeof api.hideLoadMore === "function") api.hideLoadMore();
    paintCards(diamonds);
    syncSwitcher();
  }

  function activate(pushHistory) {
    var api = bridge();
    if (!api) return;
    noteInventory();
    if (pushHistory && !hasCompare()) writeUrl(urlWithCompare(true), false);
    active = true;
    if (typeof api.holdSearchGrid === "function") api.holdSearchGrid(true);
    setModeChrome(true);
    renderActive();
  }

  function deactivate() {
    active = false;
    var api = bridge();
    if (api && typeof api.holdSearchGrid === "function") api.holdSearchGrid(false);
    if (api && typeof api.setResultCountOverride === "function") api.setResultCountOverride(null);
    setModeChrome(false);
  }

  function exitToSearch(replace) {
    if (hasCompare()) writeUrl(urlWithCompare(false), replace === true);
    deactivate();
    var api = bridge();
    if (api && typeof api.showCachedSearch === "function") api.showCachedSearch();
    else if (api && typeof api.restoreLoadMore === "function") api.restoreLoadMore();
  }

  function onAvailability() {
    var api = bridge();
    if (!api) return;
    if (!active) noteInventory();
    syncSwitcher();
    if (!active && !hasCompare()) return;
    if (hasCompare() && !active) {
      activate(false);
      return;
    }
    if (!active) return;
    var count = typeof api.availableCount === "function" ? api.availableCount() : 0;
    var pending = typeof api.isBatchPending === "function" && api.isBatchPending();
    if (count < 1 && !pending) {
      exitToSearch(true);
      return;
    }
    renderActive();
  }

  function enter() {
    var api = bridge();
    if (!api || typeof api.availableCount !== "function") return;
    if (api.availableCount() < 1) return;
    if (active && hasCompare()) return;
    activate(true);
  }

  function interceptReload() {
    if (!active) return;
    if (hasCompare()) writeUrl(urlWithCompare(false), true);
    deactivate();
  }

  function onPopState() {
    if (hasCompare()) {
      var api = bridge();
      if (api && typeof api.restoreFiltersWithoutReload === "function") {
        api.restoreFiltersWithoutReload();
      }
      if (!active) activate(false);
      else renderActive();
      return true;
    }
    if (active) deactivate();
    return false;
  }

  window.DiamondSearchCompare = {
    COMPARE_PARAM: COMPARE_PARAM,
    isActive: function () {
      return active;
    },
    enter: enter,
    onAvailability: onAvailability,
    interceptReload: interceptReload,
    onPopState: onPopState,
  };

  var api = bridge();
  if (api && typeof api.holdSearchGrid === "function" && hasCompare()) {
    api.holdSearchGrid(true);
  }

  function watchInventory() {
    var el = document.querySelector("[data-results-count]");
    if (!el || el.__ivanovCompareCountWatch || typeof window.MutationObserver !== "function") return;
    el.__ivanovCompareCountWatch = true;
    var observer = new window.MutationObserver(function () {
      if (active) return;
      noteInventory();
      syncSwitcher();
    });
    observer.observe(el, { childList: true, characterData: true, subtree: true });
  }

  function boot() {
    watchInventory();
    if (hasCompare()) activate(false);
    else syncSwitcher();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})(window, document);
